import { render, staticRenderFns } from "./list-intakes.component.vue?vue&type=template&id=0aa9d541"
import script from "./list-intakes.component.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-intakes.component.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports